<template>
    <div class="container-fluid">
        <table class="table table-striped notifications-table">
            <thead>
            <tr v-show="showLoading" class="side-borders th_font">
                <td colspan="6" class="text-center">
                    <i class="fa fa-spinner fa-spin fa-3x grey"></i><br/><br/>
                    Loading snoozes
                </td>
            </tr>

            <tr class="side-borders th_font">
                <th v-for="header in headers" v-show="!showLoading" @click="sortHeader(header.name)"
                    :style="{ width: getHeaderWidth(header) }">
                    {{ header.name | capitalize }}
                    <i class="fas fa-sort-down" v-if="header.sort === 'desc'"></i>
                    <i class="fas fa-sort-up" v-if="header.sort === 'asc'"></i>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="snooze in snoozes" v-if="!showLoading">
                <td>{{ snooze.agency.name }} ({{ snooze.agency.id }})</td>
                <td>{{ snooze.notification_type }}
                    <span class="pull-right"><i class="fa fa-sync-alt fa-spin" v-if="snooze.saving"></i></span>
                </td>
                <td>
                    <select class="form-control" @change="saveSnooze(snooze, $event)">
                        <option value="" selected>{{ "(" + snooze.snoozed_days + " days)" }}</option>
                        <option value="1">1d</option>
                        <option value="2">2d</option>
                        <option value="3">3d</option>
                        <option value="5">5d</option>
                        <option value="7">7d</option>
                        <option value="14">14d</option>
                        <option value="21">21d</option>
                        <option value="30">30d</option>
                        <option value="60">60d</option>
                        <option value="90">90d</option>
                    </select>

                </td>
                <td>
                    <div class="btn btn-danger" @click="deleteSnooze(snooze)">x</div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: "notification-snoozes",
    props: ['environment'],
    data() {
        return {
            is_loading: false,
            isSavingSnooze: false,
            headers: [
                {name: 'agency', api_name: 'agency_id', width: '165px', sort: null, sortable: true,},
                {name: 'type', api_name: 'notification_type', width: '240px', sort: null, sortable: true,},
                {name: 'snoozed until', api_name: 'snoozed_until', width: '140px', sort: null, sortable: true,},
                {name: '', sort: null, width: '43px', sortable: false,}
            ],
            //statuses: [],
            //types: [],
            snoozes: [],

            api_params: {
                order: 'snoozed_until',
                order_direction: 'desc',
                search: '',
                agency_id: '',
                types: [],
            },
        };
    },
    mounted() {
        this.getNotificationSnoozes();
    },
    computed: {
        showLoading() {
            return this.is_loading;
        },
    },
    methods: {
        getNotificationSnoozes() {
            this.is_loading = true;
            axios.get('/notifier/snoozes/data', {params: this.api_params})
                .then(response => {
                    this.snoozes = response.data;
                    this.is_loading = false;
                });
        },
        getHeaderWidth(header) {
            return (header.hasOwnProperty('width')) ? header.width : false;
        },

        sortHeader(name) {
            let header = this.getHeaderByName(name);
            let currentSort = header.sort;

            if (header.sortable === false) {
                return;
            }

            this.resetHeaderSort();

            switch (currentSort) {
                case null:
                    header.sort = 'asc';
                    break;
                case 'asc':
                    header.sort = 'desc';
                    break;
                case 'desc':
                    header.sort = 'asc';
                    break;
            }

            this.api_params.order = header.api_name;
            this.api_params.order_direction = header.sort;

            this.getNotificationSnoozes();
        },
        getHeaderByName(name) {
            return this.headers.find(h => h.name === name);
        },
        resetHeaderSort() {
            this.headers.forEach(h => h.sort = null);
        },

        saveSnooze(snooze, event) {
            var selected_days = event.target.value;

            Vue.set(snooze, 'saving', true);
            axios.post('/notifier/agency/' + snooze.agency_id + '/snoozes/' + snooze.notification_type + '/edit', {
                "snooze_days": selected_days
            }).then(response => {
                Vue.set(snooze, 'saving', false);
            });
        },
        deleteSnooze(snooze) {
            Vue.set(snooze, 'saving', true);
            axios.post('/notifier/agency/' + snooze.agency_id + '/snoozes/' + snooze.notification_type + '/edit', {
                "snooze_days": 0
            }).then(response => {
                Vue.set(snooze, 'saving', false);
                this.$delete(this.snoozes, this.snoozes.indexOf(snooze));
            });
        },
    },
    watch: {}
}
</script>

<style scoped>
.notifications-table {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
}
</style>